import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const MarketAlertCard = ({ alert }) => {
  const getPriorityColor = () => {
    switch (alert?.priority) {
      case 'high':
        return 'bg-error/10 border-error text-error';
      case 'medium':
        return 'bg-warning/10 border-warning text-warning';
      case 'low':
        return 'bg-success/10 border-success text-success';
      default:
        return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getPriorityIcon = () => {
    switch (alert?.priority) {
      case 'high':
        return 'AlertCircle';
      case 'medium':
        return 'AlertTriangle';
      case 'low':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 hover:shadow-md transition-shadow duration-300">
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${getPriorityColor()}`}>
          <Icon name={getPriorityIcon()} size={20} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h4 className="text-sm md:text-base font-semibold text-foreground line-clamp-2">{alert?.title}</h4>
            <span className="text-xs text-muted-foreground whitespace-nowrap">{alert?.time}</span>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground mb-3 line-clamp-2">{alert?.description}</p>
          <div className="flex flex-wrap items-center gap-2">
            <span className={`px-2 py-1 rounded text-xs font-medium ${getPriorityColor()}`}>
              {alert?.priority?.toUpperCase()}
            </span>
            <span className="px-2 py-1 rounded text-xs font-medium bg-muted text-muted-foreground">
              {alert?.category}
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" fullWidth iconName="Eye" iconPosition="left">
          View Details
        </Button>
        <Button variant="ghost" size="sm" iconName="X" className="flex-shrink-0" />
      </div>
    </div>
  );
};

export default MarketAlertCard;